import { dehydrate, QueryClient } from 'react-query';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import TerapiRegeneratif from 'src/containers/TerapiRegeneratif';
import wrapper from 'src/redux';
import { actionGetDownload, actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));

const StemCell = () => {
	return (
		<>
			<HeadC
				title="Manfaat Stem Cell: Inovasi Kesehatan untuk Penyakit Berat"
				description={
					'Pelajari manfaat stem cell untuk kesehatan dan kecantikan! ' +
					'Temukan inovasi terbaru dalam terapi sel punca ' +
					'yang dapat membantu regenerasi dan peremajaan tubuh Kamu.'
				}
			/>
			<TerapiRegeneratif />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	const queryClient = new QueryClient();

	await store.dispatch(await actionGetMenu());
	await store.dispatch(await actionGetFooterMenu());
	await store.dispatch(await actionGetDownload());

	return {
		props: {
			dehydratedState: dehydrate(queryClient),
			isDrawerOnly: true,
		},
	};
});

export default StemCell;
